import { Injectable, EventEmitter } from '@angular/core';
import { Configuration } from '../configurations/shared.config';
import { Transporter } from '../dataModels/transporter';
import { AuthenticationService } from './authentication.service';
import { Subject } from 'rxjs';

declare var $;

@Injectable()
export class RealTimeService {

    private proxy: any; // private proxy: HubProxy;
    private proxyName: string = 'deviceHub';
    private connection;


    public updateReceived: Subject<any>;
    public StateReceive: EventEmitter<any>;
    public connectionEstablished: EventEmitter<Boolean> = new EventEmitter<Boolean>();
    public connectionStateChanged: EventEmitter<any> = new EventEmitter<any>();
    public connectionExists: Boolean;

    constructor(private _authService: AuthenticationService) {


    }

    private startConnection(): void {

        this.connection.start().done((data) => {

            this.connectionEstablished.emit(true);
            this.connectionExists = true;

        }).fail((error) => {

            this.connectionEstablished.emit(false);
            setTimeout(() => {
                this.startConnection()
            }, 1000);
            return;

        });
    }

    private registerOnServerEvents(): void {

        this.proxy.on('receiveUpdate', (data: Transporter) => {
            this.updateReceived.next(data);
        });
        this.proxy.on('receiveUpdateStates', (data: any) => {
            this.StateReceive.emit(data);
        });
    }

    public load() {
     
        this.updateReceived = new Subject<any>();
        this.StateReceive = new EventEmitter<any>();
        this.connectionExists = false;

        this.connection = $.hubConnection(Configuration.urls.signalrEndpoint);

        //get current user
        var currentUser: any = this._authService.getCurrentUser();

        if (currentUser && currentUser.access_token) {
            this.connection.qs = { 'access_token': currentUser.access_token };
        }


        this.proxy = this.connection.createHubProxy(this.proxyName);

        this.connection.stateChanged((event) => {
            this.connectionStateChanged.emit(event);

            if (event.newState == ConnectionState.disconnected) {
                this.startConnection();
            }
        });

        this.registerOnServerEvents();

        this.startConnection();
    }

    public unload() {
        this.connection.stop();
        this.connectionExists = false;
    }
}

export enum ConnectionState {

    connecting = 0,
    connected = 1,
    reconnecting = 2,
    disconnected = 4
}


// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/services/realtime.service.ts